module.exports = __webpack_public_path__ + "img/3.775b15a7.png";